const STORAGE_KEY = "nm_contacts_content";

const DEFAULT_DATA = {
  title: "Контакты",
  description:
    "В случае если вам нужна более подробная информация, мы с радостью ответим на ваши вопросы. Пишите нам на почту email@gmail.ru или обращайтесь по телефону +7 (8412) 23 47 97",
  email: "email@gmail.ru",
  addressLabel: "Адрес офиса",
  address: "440026, РФ, Пенза, ул. Лермонтова, 3, офис 442",
  scheduleLabel: "Режим работы",
  workdaysTitle: "Рабочие дни",
  workdaysTime: "с 9-00 до 19-00",
  weekendsTitle: "Выходные дни",
  weekendsTime: "Суббота — воскресенье",
  salesLabel: "Отдел продаж",
  salesPhone: "+7 (8412) 23 47 97",
  logisticsLabel: "Отдел логистики",
  logisticsPhone: "+7 (8412) 23 47 97",
  emailLabel: "Email",
  requisitesText: "Скачать реквизиты",
  requisitesUrl: "#",
  requisitesFileName: "",
  mapX: "53.184451",
  mapY: "45.007015",
  mapZoom: "17",
};

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function toTelHref(phone) {
  const digits = String(phone || "").replace(/\D/g, "");
  if (!digits) return "#";
  if (digits.length === 11 && digits.startsWith("8")) {
    return `tel:+7${digits.slice(1)}`;
  }
  if (digits.length === 11 && digits.startsWith("7")) {
    return `tel:+${digits}`;
  }
  return `tel:+${digits}`;
}

function normalizeData(raw) {
  const fallback = { ...DEFAULT_DATA };
  if (!raw || typeof raw !== "object") return fallback;

  const next = {};
  Object.keys(fallback).forEach((key) => {
    if (key === "requisitesUrl") {
      const value = String(raw[key] ?? "").trim();
      next[key] = value || fallback[key];
      return;
    }
    if (key === "requisitesFileName") {
      next[key] = String(raw[key] ?? "").trim();
      return;
    }
    const value = String(raw[key] ?? fallback[key]).trim();
    next[key] = value || fallback[key];
  });

  // Старые плейсхолдеры {{email}} / {{phone}} заменяем на обычный текст
  if (next.description.includes("{{email}}") || next.description.includes("{{phone}}")) {
    const legacyPhone = String(raw.phone || next.salesPhone || "+7 (8412) 23 47 97").trim();
    next.description = next.description
      .replace(/\{\{email\}\}/g, next.email)
      .replace(/\{\{phone\}\}/g, legacyPhone);
  }

  return next;
}

function getContactsData() {
  const cached = window.NMApi?.cache?.contacts;
  if (cached) return normalizeData(cached);
  return normalizeData(DEFAULT_DATA);
}

function saveContactsData(data) {
  const normalized = normalizeData(data);
  if (window.NMApi) {
    window.NMApi.cache.contacts = normalized;
    window.NMApi.save("contacts", normalized).catch((error) => {
      window.alert(error.message || "Не удалось сохранить контакты"); // eslint-disable-line no-alert
    });
  }
  return normalized;
}

function setText(root, selector, value) {
  const node = root.querySelector(selector);
  if (node) node.textContent = value;
}

function renderDescriptionHtml(data) {
  return escapeHtml(data.description).replace(/\n/g, "<br>");
}

function hydrateContactsPage() {
  const root = document.querySelector("[data-contacts-root]");
  if (!root) return;

  const data = getContactsData();

  setText(root, "[data-contacts-title]", data.title);
  setText(root, "[data-contacts-address-label]", data.addressLabel);
  setText(root, "[data-contacts-address]", data.address);
  setText(root, "[data-contacts-schedule-label]", data.scheduleLabel);
  setText(root, "[data-contacts-workdays-title]", data.workdaysTitle);
  setText(root, "[data-contacts-workdays-time]", data.workdaysTime);
  setText(root, "[data-contacts-weekends-title]", data.weekendsTitle);
  setText(root, "[data-contacts-weekends-time]", data.weekendsTime);
  setText(root, "[data-contacts-sales-label]", data.salesLabel);
  setText(root, "[data-contacts-logistics-label]", data.logisticsLabel);
  setText(root, "[data-contacts-email-label]", data.emailLabel);
  setText(root, "[data-contacts-requisites-text]", data.requisitesText);

  const description = root.querySelector("[data-contacts-description]");
  if (description) {
    description.innerHTML = renderDescriptionHtml(data);
  }

  const sales = root.querySelector("[data-contacts-sales-phone]");
  if (sales) {
    sales.textContent = data.salesPhone;
    sales.setAttribute("href", toTelHref(data.salesPhone));
  }

  const logistics = root.querySelector("[data-contacts-logistics-phone]");
  if (logistics) {
    logistics.textContent = data.logisticsPhone;
    logistics.setAttribute("href", toTelHref(data.logisticsPhone));
  }

  const email = root.querySelector("[data-contacts-email]");
  if (email) {
    email.textContent = data.email;
    email.setAttribute("href", `mailto:${data.email}`);
  }

  const requisites = root.querySelector("[data-contacts-requisites]");
  if (requisites) {
    const raw = data.requisitesUrl && data.requisitesUrl !== "#" ? data.requisitesUrl : "";
    const href = window.NMSanitize?.safeHref?.(raw, { allowData: true }) || "#";
    requisites.setAttribute("href", href);
    if (href !== "#" && data.requisitesFileName) {
      requisites.setAttribute("download", data.requisitesFileName);
    } else if (href.startsWith("data:")) {
      requisites.setAttribute("download", "requisites");
    } else {
      requisites.removeAttribute("download");
    }
  }

  const mapCoords = root.querySelector("[data-contacts-map-coordinates]");
  if (mapCoords) {
    mapCoords.setAttribute("data-x", data.mapX);
    mapCoords.setAttribute("data-y", data.mapY);
    mapCoords.setAttribute("data-zoom", data.mapZoom);
    window.NMMap?.initWhenReady?.();
  }
}

window.NMContactsContent = {
  STORAGE_KEY,
  escapeHtml,
  toTelHref,
  getContactsData,
  saveContactsData,
  getDefaultData: () => normalizeData(DEFAULT_DATA),
  normalizeData,
  hydrateContactsPage,
};

window.NMApi?.ready?.then(hydrateContactsPage);
